export const Region = {
  MALAYSIA: "MY",
  INDO: "ID",
};

export const hideCompanyList = ["joker", "playtech", "ebet"];

export const malaysiaDatabaseName = "ok99MemberMYR"

